import { login } from '@/api/common/common';
import common from "@/assets/js/common";
import store from '../store';
import router from '../router';
export function webLogin(){
    const params = new URLSearchParams(window.location.search);
    let loginName=(params.get('loginName')?decodeURIComponent(params.get('loginName')):'');
    let passwd=(params.get('passwd')?decodeURIComponent(params.get('passwd')):'');
    let name = common.getCookie("loginName");
    console.log(loginName,passwd,name,params)
    if(!loginName||!passwd||loginName==name)return;
    let data={
        "appCode": process.env.VUE_APP_APP_CODE,
        "device": "",
        "loginName": loginName,
        "passwd":passwd,
      };
      login(data).then(res=>{
        if(res.code==200){
            store.dispatch('setUserData', res.data);
            store.commit('changeUserInfo', res.data);
            window.open(location.origin+location.pathname,'_self');
        }
      });
};

export function isBackOrStage(){
  var tenanId = common.getCookie('tenantId');
  if (tenanId == -1&&router.currentRoute.meta.classify=='manage') {
      router.push('/AdminLogin');
  }else if(router.currentRoute.meta.classify=='manage'){
      store.commit('changeGoLogin', 'login');
  }else {
      router.push('/');
  }
  localStorage.clear();
  store.commit('del_token');
  store.commit('changeUserInfo', {});
};